// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import { CONFIG } from "~/config";
import { firmStats, reviewHasColoredBadge, reviewHasGreenBadge, isFirmFromPoi, getBadgeComponent } from "~/util/review";
import { createMarkerInfoPlace } from "~/ui/markerinfo";
import Scene from "~/scene";
import { store } from "~/state/store";
import { watch, watchAnimation } from "~/state/util";
import { ROUTE_CONST } from "~/route/const";
import { description, getIcon } from "./util/providers/poiagg";

/* ************************************************** marker poi ********************************************************* */

/**
 * Zakladni prvek na mapy.cz, dedi z interface MarkerIPOI, rozisiruje marker poi z API.
 */

Mapy.MarkerPOI = function(coords, id, opts) {
	SMap.WMMarker.call(this, coords, id, opts);

	if ("key" in this._conf) {
		this._id = `${this._id}-${this._conf.key}`;
	}

	this._sceneListeners = [];
	// TODO: tohle se taky musi casem zrusit, ale to az cely nastroj bude pracovat nad SMap instanci a ne nad Scene
	this._sceneListeners.push(Scene.addListener("map-pan", "_mapPanoZoomEvent", this));
	const wt = watch(store.getState, "map", watchAnimation);

	this._storeAnimationUnsubscribe = store.subscribe(wt(newMap => {
		if (newMap.animating) {
			this._mapPanoZoomEvent();
		}
	}));
};

Mapy.MarkerPOI.prototype = Object.create(Object.assign({}, Mapy.MarkerCard.prototype, SMap.Marker.prototype, SMap.WMMarker.prototype));

Mapy.MarkerPOI.prototype.$destructor = function () {
	SMap.WMMarker.prototype.$destructor.call(this);

	Scene.removeListeners(this._sceneListeners);
	this._storeAnimationUnsubscribe?.();
	this._storeAnimationUnsubscribe = null;
};

/**
 * Nastavení zdroje POIe.
 * @param {string} source
 */
Mapy.MarkerPOI.prototype.setSource = function(source) {
	this._source = source;
	this._updateAttributes();
	return this;
}

/**
 * Nastavení ID POIe.
 * @param {number} plainId
 */
Mapy.MarkerPOI.prototype.setPlainId = function(plainId) {
	this._plainId = plainId;
	this._updateAttributes();
	return this;
}

Mapy.MarkerPOI.prototype._updateAttributes = function() {
	var elm = this._dom.active;
	elm.setAttribute("data-log-action", "card-poi");
	elm.setAttribute("data-log-source", this._source);
	elm.setAttribute("data-log-id", this._plainId);

	// neni pro nove typy
	if (elm.nodeName.toLowerCase() == "a") {
		elm.href = CONFIG.mapyURL + "/?source=" + this._source + "&id=" +  this._plainId/* + "&show=1"*/;
	}
};

/**
 * Jedná se o vizuální reprezentaci detailu?
 * @return {Boolean}
 */
Mapy.MarkerPOI.prototype.isDetail = function() {
	const { data } = store.getState().detail;

	if (!this._poi || !data) {
		return false;
	}

	return data.source === this._poi.source && data.id === this._poi.id;
};

Mapy.MarkerPOI.prototype.click = function(e, elm) {
	// nechceme pro detail
	if (!this.isDetail()) {
		// u prostredniho kliku na <a> nechame otevrit tab v novem okne
		var target = e.target && e.target.closest("a");
		var elm = this.getContainer()[SMap.LAYER_MARKER];
		var cont = elm.nodeName.toLowerCase();

		if ((target || cont == "a") && Mapy.Util.linkToNewWindow(e)) {
			return;
		}

		// pro male rozliseni chceme popup, ne detail
		if (Mapy.Util.isSmallResolution() && !CONFIG.inFrame) {
			e.preventDefault();
			return;
		}
	}

	e.preventDefault();
	SMap.WMMarker.prototype.click.call(this, e, elm);


	var map = this.getMap();

	if (map) {
		map.getSignals().makeEvent("marker-poi-click", this, {event:e});
	}
};

Mapy.MarkerPOI.prototype.setTitle = function(title) {
	this._title = title;
};

Mapy.MarkerPOI.prototype.getTitle = function() {
	return this._title || this._options.title;
};

Mapy.MarkerPOI.prototype.setPopupFromPOI = function(poi) {
	this.setPopupCallback(function(card) {
		return this._getDesc(poi).then(function(desc) {
			this._setPopupCont(card, desc);
		}.bind(this), () => {});
	}.bind(this));
};

/**
 * Ziskani description dat pro poi - obrazek, oteviraci doba, atd.
 *
 * @param {object} poi data pro naplneni vizitky (napr. z getDescription, nebo detailu)
 * @return {JAK.Promise}
 */
Mapy.MarkerPOI.prototype._getDesc = function(poi) {
	var promise = new JAK.Promise();

	description([poi], {
		fetchPhoto:true,
		ratios:['1x1'],
		lang: CONFIG.langPriority,
		query: Mapy.getComponent("search").getQuery(),
		reviews: true,
		wikimedia: true,
	}).then(function(r) {
		// merge poi + desc
		if (r.poi && r.poi.length === 1) {
			Object.assign(poi, r.poi[0]);
		}

		// promise is done
		promise.fulfill(poi);
	}, () => {});

	return promise;
};

Mapy.MarkerPOI.fromPOI = function(poi, id, opts) {
	var markerCoords = SMap.Coords.fromWGS84(poi.mark.lon, poi.mark.lat);
	var typeId = "universal";
	if (poi.markerId) { typeId = poi.markerId; }
	var params = {
		type: SMap.WMMarker.TYPES[typeId.toUpperCase()],
		scale: 2, // skalovani ikon
		onlyIcon: false // nastavit pouze ikonu, def. false
	};

	Object.assign(params, Mapy.CDN.SIZE_60_60, opts);

	if (!params.width || !params.height) {
		params.width = SMap.WMMarker.TYPES[typeId.toUpperCase()].size[0];
		params.height = SMap.WMMarker.TYPES[typeId.toUpperCase()].size[1];
	}

	var media = params.media || poi.media || {};
	var urls = media.urls || {};
	var favicon = poi.icon && "1" in poi.icon ? poi.icon["1"] : (poi.favicon ? poi.favicon : "");

	// priorita: favicon - image - icon
	if(!params.onlyIcon && urls["1x1"] && !favicon) {
		params.img = Mapy.CDN.setSize(urls["1x1"], params);
	}
	// favicona se chova jako ikona
	else if (favicon) {
		params.icon = favicon;
		params.favicon = true;

		var srcset = [];
		for (var key in poi.icon) {
			srcset.push(poi.icon[key] + " " + key + "x");
		}
		params.srcset = srcset.length > 1 ? srcset.join(", ") : "";
	}
	else {
		var icon = getIcon(poi.typeId || poi.poiTypeId, { scale: params.scale });

		if (icon) {
			params.icon = icon;
			var icon2x = getIcon(poi.typeId || poi.poiTypeId, { scale: params.scale * 2 });
			params.srcset = icon + " 1x" + (icon2x ? ", " + icon2x + " 2x" : "");
		}
		else {
			params.img = "";
		}
	}

	// rotace ikony
	if (poi.rotateDeg) {
		params.rotateDeg = poi.rotateDeg;
	}

	// klic v multimarkerech u dopravnich udalsoti
	if ("key" in poi) {
		params.key = poi.key;
	}

	var marker = new Mapy.MarkerPOI(markerCoords, id, params);
	marker.setPOI(poi);

	return marker;
};

/**
 * Zakladni lookupy.
 */
Mapy.MarkerPOI.fromData = function(data) {
	var options = {
		title: "", // nechceme title, kdyz je vizitka
		type: SMap.WMMarker.TYPES[data.paid ? "PAID" : "POI"],
		scale: 1
	};
	var id = undefined;

	if (data.paid) {
		options.paid = data.paid;
	} else {
		if (data.anchor) {
			options.anchor = data.anchor;
		}
		if (data.size) { options.size = data.size; }
	}

	if (data.icon && "1" in data.icon) {
		options.url = data.icon["1"];
	}
	else if (data.url) {
		options.url = data.url;
	}

	if ("source" in data && "id" in data) {
		id = data.source+data.id;
	}

	// klic v multimarkerech u dopravnich udalsoti
	if ("key" in data) {
		options.key = data.key;
	}

	var marker = Mapy.MarkerPOI.fromPOI(data, id, options);

	marker.setTitle(data.title);
	marker.setSource(data.source);
	marker.setPlainId(data.id);
	marker.setPopupFromPOI(data);

	var elm = marker.getContainer()[SMap.LAYER_MARKER];
	elm.classList.add("lookup-poi");
	if (data.future) {
		elm.classList.add("lookup-poi--future");
	}

	if (data.past) {
		elm.classList.add("lookup-poi--past");
	}

	return marker;
};

Mapy.MarkerPOI.prototype._mapPanoZoomEvent = function() {
	if (this.getCard()) {
		this.removeCard();
	}
}

/* ************************************************** marker poi - detail ********************************************************* */

Mapy.MarkerDetail = function(coords, poi, params) {
	Mapy.MarkerPOI.call(this, coords, null, params);

	this._titlePosition = "";

	if(poi && poi.source != "foto" && poi.source != "ffoto") {
		this.setPopupCallback(function(card) {
			this._setPopupCont(card, poi, true);
		}.bind(this));
	}

	this._mousePos = {
		x: 0,
		y: 0
	};

	// pro detail s popupem nechceme titulek
	this._title = "";
	this._dom.active.title = "";

	this._firstMouseEnter = true;
};

Mapy.MarkerDetail.prototype = Object.create(Mapy.MarkerPOI.prototype);

Mapy.MarkerDetail.prototype.setCoords = function(coords) {
	this._firstMouseEnter = true;
	Mapy.MarkerPOI.prototype.setCoords.call(coords);
}

Mapy.MarkerDetail.prototype.handleEvent = function(e) {
	if (e.type == "mousemove") {
		this._onMarkerMouseMove(e);
	}
}

// prepiseme interface
Mapy.MarkerDetail.prototype._getAddress = function(poi) {
	var label = "";
	if (poi.extend && poi.extend.address) {
		var address = poi.extend.address;
		label = Mapy.Util.formatAddress(address, true);
	}
	return label;
}

Mapy.MarkerDetail.prototype._mouseEnter = function(e) {
	if (this._firstMouseEnter) {
		// zapamatujeme si pozici mysi kvuli chromu, kterej zavola rovnou i mousemove
		this._mousePos.x = e.clientX;
		this._mousePos.y = e.clientY;

		this._dom.container[SMap.LAYER_MARKER].addEventListener("mousemove", this, false);
		this._firstMouseEnter = false;
	}
	else {
		Mapy.MarkerPOI.prototype._mouseEnter.call(e);
	}
}

Mapy.MarkerDetail.prototype._onMarkerMouseMove = function(e) {
	var diffX = e.clientX - this._mousePos.x;
	var diffY = e.clientY - this._mousePos.y;

	if (!diffX && !diffY) return;

	this._dom.container[SMap.LAYER_MARKER].removeEventListener("mousemove", this, false);
	this._mouseEnter(e);
}

Mapy.MarkerDetail.fromPOI = function(poi, id, opts) {
	var markerCoords = SMap.Coords.fromWGS84(poi.mark.lon, poi.mark.lat);
	var params = {
		fromMarker: null,
		best: null,
		type: SMap.WMMarker.TYPES.BIG,
		scale: 1.5, // skalovani ikon
		onlyIcon: false, // nastavit pouze ikonu, def. false
		size: [30, 30],
	};

	Object.assign(params, Mapy.CDN.SIZE_60_60, opts);


	let poiMedia = poi?.media;
	if (params.fromMarker && typeof params.fromMarker.getConf === "function" && params.fromMarker.getType() === SMap.WMMarker.TYPES.BIG) {
		poiMedia = params.fromMarker.getPOI()?.media;
	}

	let poiIcon = poi.icon ? JSON.parse(JSON.stringify(poi.icon)) : "";
	if (poiIcon && "1" in poiIcon && "2" in poiIcon && "3" in poiIcon) {
		poiIcon["1"] = poiIcon["2"];
		poiIcon["2"] = poiIcon["3"];
		delete poiIcon["3"];
	}

	var media = params.best || params.media || poiMedia || {};
	var urls = media.urls || {};
	var favicon = poiIcon && "1" in poiIcon ? poiIcon["1"] : (poi.favicon ? poi.favicon : "");

	// priorita: favicon - image - icon
	if(!params.onlyIcon && urls["1x1"] && (!favicon || favicon == "")) {
		params.img = Mapy.CDN.setSize(urls["1x1"], params);
	}
	// favicona se chova jako ikona
	else if (favicon && favicon != "") {
		params.icon = favicon;
		params.favicon = true;

		var srcset = [];
		for (var key in poiIcon) {
			srcset.push(poiIcon[key] + " " + key + "x");
		}
		params.srcset = srcset.length > 1 ? srcset.join(", ") : "";
	}
	else if (!params.icon || params.icon == "") {
		var icon = getIcon(poi.typeId || poi.poiTypeId, { scale: params.scale });

		if (icon) {
			params.icon = icon;
			var icon2x = getIcon(poi.typeId || poi.poiTypeId, { scale: params.scale * 2 });
			params.srcset = icon + " 1x" + (icon2x ? ", " + icon2x + " 2x" : "");
		}
		else {
			params.img = "";
		}
	}

	// pro vlastni elementy nechceme kolecko
	if (!params.icon && !params.img && !params.elm && params.type == SMap.WMMarker.TYPES.BIG) {
		params.type = SMap.WMMarker.TYPES.UNIVERSALBIG;
	}

	// titulek k markeru
	const descElm = node("div", { className: "poi-desc" });
	const titleCont = node("div", { className: "poi-title" });
	const titleText = opts.usertitle ? opts.usertitle : poi.title != "" ? poi.title : poi.firstRow
	const title = node("span", {}, titleText);

	titleCont.append(title)
	descElm.append(titleCont);

	if (poi.review && reviewHasColoredBadge(poi.review)) {
		descElm.appendChild(node(getBadgeComponent(), {
			rating: poi.review.review_rating_stars,
			top: Mapy.CUS.userweb.badgeWCMapGreen || reviewHasGreenBadge(poi.review),
			size: "small",
		}));
	}

	params.elm = descElm;
	params.onlyElm = false;

	var marker = new Mapy.MarkerDetail(markerCoords, poi, params);
	marker.setPOI(poi);

	this._titlePosition = params.fromMarker?.getTitlePosition && params.fromMarker.getTitlePosition() != "" ? params.fromMarker.getTitlePosition() : "right";

	marker.getContainer()[SMap.LAYER_MARKER].classList.add("show-title");
	marker.getContainer()[SMap.LAYER_MARKER].classList.add(`text-${this._titlePosition}`);

	return marker;
};

Mapy.MarkerDetail.prototype.getTitlePosition = function() {
	return this._titlePosition;
}

/* ************************************************** marker poi - search ********************************************************* */

Mapy.MarkerSearch = function(coords, id, opts) {
	Mapy.MarkerPOI.call(this, coords, id, opts);

	this._reported = [];

	this._titlePosition = "";

	if (!CONFIG.inFrame) {
		this.setCardOptions({
			cb: function(card) {
				// stahujeme description
				if (this._poi.markerId == "little" || this._poi.markerId == "small") {
					return this._getDesc(this._poi).then(function(desc) {
						this._setPopupCont(card, desc);
					}.bind(this), () => {});
				}
				// jiz ho mame
				else {
					this._setPopupCont(card, this._poi);
				}
			}.bind(this),
			rqTimeout: 200,
			showTimeout: 300
		});
	}

	// analytika
	var elm = this.getContainer()[SMap.LAYER_MARKER];
	var query = Mapy.getComponent("search").getState().q || "";
	elm.setAttribute("data-log-ignore", "1");
	elm.addEventListener("pointerdown", () => {
		// analytika
		let logObj = {
			search_type: "searchmap"
		};
		let filters = Mapy.getComponent("search").getFilters();
		if (Object.keys(filters).length) {
			logObj.filter_id = "";
			logObj.filter_type = "";
			for (let f in filters) {
				logObj.filter_id += (logObj.filter_id !== "" ? "," : "") + filters[f].id;
				logObj.filter_type += (logObj.filter_type !== "" ? "," : "") + filters[f].type;
			}
		}
		Mapy.Util.analyticsSearchSelection(logObj, this._poi);
	});
};

Mapy.MarkerSearch.prototype = Object.create(Mapy.MarkerPOI.prototype);

Mapy.MarkerSearch.fromPOI = function(poi, id, opts) {
	var markerCoords = SMap.Coords.fromWGS84(poi.mark.lon, poi.mark.lat);
	var typeId = "small";
	if (poi.markerId && poi.markerId != "universal") { typeId = poi.markerId; }
	var params = {
		type: SMap.WMMarker.TYPES[typeId.toUpperCase()],
		scale: 1, // skalovani ikon
		onlyIcon: false // nastavit pouze ikonu, def. false
	};
	Object.assign(params, Mapy.CDN.SIZE_60_60, opts);

	if (!params.width || !params.height) {
		params.width = SMap.WMMarker.TYPES[typeId.toUpperCase()].size[0];
		params.height = SMap.WMMarker.TYPES[typeId.toUpperCase()].size[1];
	}

	var media = params.media || poi.media || {};
	var urls = media.urls || {};
	var favicon = poi.icon && "1" in poi.icon ? poi.icon["1"] : (poi.favicon ? poi.favicon : "");

	// priorita: favicon - image - icon
	if(!params.onlyIcon && urls["1x1"] && !favicon && !(poi.markerId == "small" && params.onlyIconOnSmall)) {
		params.img = Mapy.CDN.setSize(urls["1x1"], params);
	}
	// favicona se chova jako ikona
	else if (favicon) {
		params.icon = favicon;
		params.favicon = true;

		var srcset = [];
		for (var key in poi.icon) {
			srcset.push(poi.icon[key] + " " + key + "x");
		}
		params.srcset = srcset.length > 1 ? srcset.join(", ") : "";
	}
	else {
		var icon = getIcon(poi.typeId || poi.poiTypeId, { scale: params.scale });

		if (icon) {
			params.icon = icon;
			var icon2x = getIcon(poi.typeId || poi.poiTypeId, { scale: params.scale * 2 });
			params.srcset = icon + " 1x" + (icon2x ? ", " + icon2x + " 2x" : "");
		}
	}

	if (!params.icon) {
		if (typeId == "small") { params.type = SMap.WMMarker.TYPES.UNIVERSAL; }
		if (!params.img && typeId == "big") { params.type = SMap.WMMarker.TYPES.UNIVERSALBIG; }
	}
	else if (!params.img && typeId == "big") {
		params.type = SMap.WMMarker.TYPES.SMALL;
	}

	var marker = new Mapy.MarkerSearch(markerCoords, id, params);
	marker.setPOI(poi);

	var cont = marker.getContainer()[SMap.LAYER_MARKER];
	cont.href = CONFIG.mapyURL + "/?source=" + poi.source + "&id=" +  poi.id;

	return marker;
};

Mapy.MarkerSearch.prototype._setPopupCont = function(card, poi) {
	Mapy.MarkerPOI.prototype._setPopupCont.call(this, card, poi);

	if (isFirmFromPoi(poi)) {
		this._firmStats("desc", poi, { placeId: 9 });
	}

	var elm = this.getContainer()[SMap.LAYER_MARKER];

	if (poi && elm) {
		elm.href = CONFIG.mapyURL + "/?source=" + poi.source + "&id=" +  poi.id;
	}
};

Mapy.MarkerSearch.prototype._firmStats = function(type, data, specParam) {
	if (this._reported.indexOf(type) == -1) {
		if (specParam.typeId) {
			firmStats("firmy-vizitka-akce", data, specParam);
		} else {
			firmStats("firmy-vizitka-doruceni", data, specParam);
		}
		this._reported.push(type);
	}
};

Mapy.MarkerSearch.prototype.showCard = function(timeout, noSendSignal) {
	timeout = typeof timeout === "number" ? timeout : this._cardOpts.showTimeout;

	if (!this._card.obj) {
		this._createCard();
	}

	// updateCard vzdycky
	this._updateCard();

	if (!noSendSignal) {
		this._makeSignal("marker-enter");
		if (this._poi) { this._makeSignal("marker-poi-enter"); }
	}
	this._clearTO("show");

	this._card.showID = setTimeout(() => {
		if (!this._owner) return;

		this._dom.active.classList.add("active");
		this.getMap().addCard(this._card.obj, this._getCardCoords(), true);
	}, timeout);
};

Mapy.MarkerSearch.prototype.showTitleText = function(show, position) {
	this._titlePosition = position;
	this._dom.container[SMap.LAYER_MARKER].classList[show ? "add" : "remove"]("show-title");
	if (show) {
		this._dom.container[SMap.LAYER_MARKER].classList.add(`text-${position}`);
	}
}

Mapy.MarkerSearch.prototype.getTitlePosition = function() {
	return this._titlePosition;
}

Mapy.MarkerSearch.prototype.showFirmBadge = function(show) {
	this._dom.container[SMap.LAYER_MARKER].classList[show ? "remove" : "add"]("no-badge");
}

Mapy.MarkerSearch.prototype.setInteractive = function(set) {
	this._dom.container[SMap.LAYER_MARKER].classList[set ? "add" : "remove"]("interactive");
}

/* ************************************************** marker poi - places ********************************************************* */

Mapy.MarkerPlace = function(coords, item, opts, id) {
	Mapy.MarkerPOI.call(this, coords, id ? id : item.id, opts);

	if (!CONFIG.inFrame) {
		this.setCardOptions({
			cb: card => {
				this._setPopupCont(card, item, opts);
			},
			showTimeout: 200,
			hideTimeout: 50,
		});
	}
}

Mapy.MarkerPlace.prototype = Object.create(Mapy.MarkerPOI.prototype);

Mapy.MarkerPlace.prototype._setPopupCont = function(card, item, opts) {
	// obsah
	const markerInfo = createMarkerInfoPlace({
		item,
		routeBtnCb: item.type === "entity" || item.type === "point" ? async () => {
			//FIXME pokud je otevreny imageuploader ma to tak zustat
			if (Mapy.getComponent("imageUploader").isActive()) {
				return;
			}

			this.removeCard();

			const route = Mapy.getComponent("route");

			if (!Mapy.CML.state.route?.items?.length) {
				Mapy.CML.state = {
					route: {
						params: {
							criterion: item.source === "pubt" ? 200 : 111,
							type: item.source === "pubt" ? ROUTE_CONST.TYPE_PUBT : ROUTE_CONST.TYPE_CAR,
						},
					},
				};
			}

			await route.addItem({
				source: item.type === "point" ? "coor" : item.source,
				position: Mapy.getComponent("route").isActive() ? ROUTE_CONST.position.start : ROUTE_CONST.position.end,
				id: item.type === "point" ? `${item.mark.lon},${item.mark.lat}` : item.source_id,
				name: item.title,
				coords: Scene.coordsFromWGS84(item.mark.lon, item.mark.lat),
				desc: item.subtitle,
				...item.usertitle ? { usertitle: item.usertitle } : {},
				favoriteId: item.id,
				..."poi_type_id" in item ? {typeId: item.poi_type_id } : {},
			});

			!CONFIG.inFrame && Mapy.getComponent("history").save();
		} : null,
		url: opts.hrefUrl || `${CONFIG.mapyURL}/?dim=${item.id}`,
	});
	var infoPart = markerInfo.info;

	// click eventy
	infoPart.addEventListener("click", e => {
		this.removeCard();

		if (!Mapy.Util.linkToNewWindow(e)) {
			e.preventDefault();

			opts.cardClick();
		}
	});

	const cardBody = card.getBody();
	Mapy.Util.clear(cardBody);
	cardBody.appendChild(infoPart);

	if (item.type === "entity" || item.type === "point") {
		cardBody.appendChild(markerInfo.seperatorPart);
		cardBody.appendChild(markerInfo.buttonPart);
	}
}

Mapy.MarkerPlace.prototype.setInteractive = function(set) {
	this._dom.container[SMap.LAYER_MARKER].classList[set ? "add" : "remove"]("interactive");
}

Mapy.MarkerPlace.prototype.setNonInteractive = function(set) {
	this._dom.container[SMap.LAYER_MARKER].classList[set ? "add" : "remove"]("non-interactive");
}

Mapy.MarkerPlace.prototype.showCard = function(timeout) {
	timeout = typeof timeout === "number" ? timeout : this._cardOpts.showTimeout;

	if (!this._card.obj) {
		this._createCard();
		this._updateCard();
	}

	this._makeSignal("marker-enter");
	if (this._poi) { this._makeSignal("marker-poi-enter"); }
	this._clearTO("show");

	this._card.showID = setTimeout(() => {
		if (!this._owner) return;

		this._dom.active.classList.add("active");
		this.getMap()?.addCard(this._card.obj, this._getCardCoords(), true);
	}, timeout);
};
